import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { Modal } from 'framework/ui/ui-builder';
import { FeedbackForm, CONTACT_SUPPORT, SUPPORT_REQUEST_ID } from 'domain/shared/oneStop';
import { ContactSupportIcon, Tooltip, Loading, LoaderSize } from 'framework/ui/mui-builder';
import { formatSupportDescription } from 'framework/utils';
import { generateLinkByEmail } from 'framework/utils';
import { Box, Link, Stack, Typography } from '@mui/material';

const SupportRequestModalDecorator = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

  const loader = (
    <Box
      role="status"
      aria-hidden="true"
      sx={{
        display: 'inline-block',
        position: 'relative',
        width: { xs: '1em', md: '17px' },
        height: { xs: '1em', md: '17px' },
        marginLeft: '11px',
      }}
    >
      <Loading size={LoaderSize.Small} />
    </Box>
  );

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openSupportForm = () => {
    setIsModalOpen(false);
    setIsFormOpen(true);
  };
  const closeSupportForm = () => setIsFormOpen(false);

  const handleTeamsButton = () => {
    const supportUserEmail = 'davinci-support@syberry.com';
    const teamsLink = generateLinkByEmail(supportUserEmail);

    window.open(teamsLink, '_blank');

    closeModal();
  };

  return (
    <>
      <IconButton className="feedback-button" onClick={openModal}>
        <Tooltip title="Contact support">
          <Stack component="span" direction="row" sx={{ display: 'inline-flex' }}>
            <ContactSupportIcon fontSize="medium" />
          </Stack>
        </Tooltip>
      </IconButton>
      <Modal
        modalSize={false}
        paperSx={{ maxWidth: '650px' }}
        isOpen={isModalOpen}
        onToggle={closeModal}
        hasCancelButton={false}
        title="Contact support"
      >
        <Stack alignItems="center" gap={2.5}>
          <Box textAlign="left" mb={2.5} maxWidth="600px" mx="auto">
            <Typography variant="subtitle1" mb={1.5}>
              Are you facing a problem that is blocking your work?
            </Typography>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ marginBottom: '10px' }}>
                <Typography component="span" variant="subtitle1">
                  • Use{' '}
                  <Link onClick={openSupportForm} color="primary" sx={{ cursor: 'pointer', textDecoration: 'none' }}>
                    OneStop request
                  </Link>{' '}
                  (default method): {isLoaderVisible && loader}
                </Typography>
                <br />
                <Typography component="span" variant="body1" ml={1}>
                  To submit a default help request for assistance.
                </Typography>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <Typography component="span" variant="subtitle1">
                  • Use{' '}
                  <Link onClick={handleTeamsButton} color="primary" sx={{ cursor: 'pointer', textDecoration: 'none' }}>
                    the support chat
                  </Link>
                  :
                </Typography>
                <br />
                <Typography component="span" variant="body1" ml={1}>
                  For urgent and important time-sensitive request that require resolution within minutes.
                </Typography>
              </li>
            </ul>
          </Box>
        </Stack>
      </Modal>
      {isFormOpen && (
        <FeedbackForm
          formId={SUPPORT_REQUEST_ID}
          formTitle={CONTACT_SUPPORT}
          setIsLoaderVisible={setIsLoaderVisible}
          closeFeedbackForm={closeSupportForm}
          technicalDescription={formatSupportDescription()}
        />
      )}
    </>
  );
};

export default SupportRequestModalDecorator;
